































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {FavoritesController} from "@share/favorites/controller/FavoritesController";
import {AgendaService} from "@share/program/data/AgendaService";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {AgendaInfoService} from "@share/program/data/AgendaInfoService";
import {CommentsService} from "@share/program/data/CommentsService";
import {Debounce} from "vue-debounce-decorator";
import FavoritesList from "@share/favorites/FavoritesList.vue";
import SessionListInfo from "@share/program/components/session-list/session-list-info/SessionListInfo.vue";
import PocketBlock from "@share/common/pocket/Pocket.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";
import {AgendaUpdateObserver} from "@share/favorites/controller/AgendaUpdateObserver";
import {Element} from "@api/models/Element";
import {removeFromFavoriteAction, restoreUnreadedAction} from "@service/store/favorites/actions";
import SessionInfoModal from "@share/program/components/parallel-agendas/SessionInfoModal.vue";
import {ObjectRepository} from "@api/repositories/ObjectRepository";

@Component({
    name: "FavoritesListWrapper",
    components: {Overlay, BounceSpinner, SessionListInfo, FavoritesList, PocketBlock, SessionInfoModal}
})
export default class FavoritesListWrapper extends Vue {
    @Prop({ default: false}) showList: boolean;

    controller: FavoritesController | null = null;
    selectedSessionId: string | null = null;
    agendaUpdateObserver: AgendaUpdateObserver | null = null;
    infoLeaveTimeId = 0;
    isMobile: boolean | null = null

    get selectedSessionForinfo() {
        return this.controller?.preparedAgendas.find((session) => session.id === this.selectedSessionId) || null;
    }

    get currentFavesList() {
        if (this.controller?.agendaService.schema) {
            return this.$store.state.favorites.list[this.controller?.agendaService.schema] ?? [];
        }
        return [];
    }

    get isLoading() {
        return this.controller?.isLoading ?? false;
    }

    mounted() {
        const objectRepository = this.$repositories.get<ObjectRepository>(RepositoryFabric.OBJECT);
        this.controller = new FavoritesController(
            this.$store,
            new AgendaService(this.$store, objectRepository),
            new AgendaInfoService(
                this.$store,
                objectRepository,
                this.$repositories.get(RepositoryFabric.EVENT_MEMBERSHIP),
                this.$repositories.get(RepositoryFabric.SESSION),
                this.$repositories.get(RepositoryFabric.RATING),
                new CommentsService(this.$store, this.$repositories.get(RepositoryFabric.COMMENT))
            )
        );
        this.agendaUpdateObserver = new AgendaUpdateObserver(
            this.controller,
            this.$repositories.get(RepositoryFabric.REALTIME),
            this.$store
        );

        if (this.showList) {
            this.runLoading();
        }

        window.addEventListener("focus", this.restoreUnreaded)
    }

    restoreUnreaded() {
        this.$store.dispatch(restoreUnreadedAction)
    }

    beforeDestroy() {
        window.removeEventListener("focus", this.restoreUnreaded)
    }

    @Watch('showList')
    async onWatchChanged(showList: boolean) {
        if(showList) {
            window.addEventListener("resize", this.windowResizeHandler)
        }
        else {
            window.removeEventListener("resize", this.windowResizeHandler)
        }
        await this.runLoading();
    }

    async runLoading() {
        if (this.showList && !this.controller?.isLoaded && !this.controller?.isLoading) {
            await this.controller?.load();
            await this.agendaUpdateObserver?.connect();
        }
    }

    @Watch('currentFavesList')
    async onCurrentFavesListChanged() {
        await this.controller?.handleFaveAgendasChange();
    }

    @Debounce(70)
    showSessionInfo(sessionId: string) {
        clearInterval(this.infoLeaveTimeId);
        this.selectedSessionId = sessionId;

        this.windowResizeHandler();
    }

    @Debounce(80)
    windowResizeHandler() {
        this.isMobile = window.innerWidth < 1024;
    }

    onFaveChanged(session: Element) {
        this.controller?.removeAgenda(session.id);
        this.$store.dispatch(removeFromFavoriteAction, { schemaId: this.controller?.agendaService.schema, objectId: session.id });
        if (this.selectedSessionId == session.id) {
            this.selectedSessionId = null;
        }
    }

    onInfoLeave() {
        this.infoLeaveTimeId = window.setTimeout(() => {
            this.selectedSessionId = null;
        }, 1000);
    }

    close() {
        this.selectedSessionId = null;
        if (this.controller?.isLoaded) {
            this.agendaUpdateObserver?.disconnect();
        }
        this.$emit('close');
        this.$router.push({path: this.$route.path})
    }
}
